import React from 'react';
import { Button, TextInput, Checkbox, Text, RTNLink, SocialButton, RtnIcon } from '@rtn-web/evergreen';

const providersUrls = {
  google: '/google/callback',
  facebook: '/auth/facebook/callback',
  linkedin: '/auth/linkedin/callback',
};
export default function SocialSignIn({
  email,
  provider,
  submitSocialForm,
  urlParams,
}) {
  return (
    <div className="social-media-login-container">
      <div className="grid-x">
        <div className="small-12 text-center">
          <RtnIcon name="HandShake" />
        </div>
        <div className="small-12 text-center">
          <br />
          <Text tag="h3" variant="para-bold-large-center" text={email} />
          <Text tag="p" variant="para-semibold-medium-center" text="It looks like you usually sign into your Roadtrip Nation account through another site! Click the button below to continue signing in." />
        </div>
        <div className="small-12 text-center">
          <form
            id="frm-social"
            className="social-form"
            name="mySocialForm"
          >
            <div className="social-btn-div mgt-24 mgb-24" style={{ display: 'flex', justifyContent: 'center' }}>
              <SocialButton
                name={provider}
                isHorizontal
                action={(e) => submitSocialForm(e, providersUrls[provider])}
              />
            </div>
          </form>
        </div>
        <div className="small-12 text-center">
          <RTNLink
            sameWindow
            link={`/user/login?${urlParams}`}
            text="I want to sign in with a different username or email"
          />
        </div>
      </div>
    </div>
  );
}
